import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Data, NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter, startWith, Subscription } from 'rxjs';
import { IconModule } from 'src/app/icon/icon.module';
import { AuthService } from 'src/app/services/auth.service';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  imports: [IconModule, RouterModule, TranslateModule],
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnDestroy {
  pageInfo: Data | any = Object.create(null);
  isAdminPage = false;
  private subscription: Subscription;
  currentUrl = "";

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.subscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null)
    ).subscribe(() => {
      this.currentUrl = this.router.url;
      this.breadcrumbService.setLastTitle(null);
    });
    this.subscription.add(this.breadcrumbService.lastTitle$.subscribe(() => this.render()));
    this.subscription.add(this.breadcrumbService.intermediateBreadcrumb$.subscribe(() => this.render()));
  }

  private render() {
    const breadcrumbs = this.buildBreadcrumb();
    const lastTitle = this.breadcrumbService.lastTitle$.value;
    if (lastTitle && breadcrumbs.length) {
      breadcrumbs[breadcrumbs.length - 1] = { ...breadcrumbs[breadcrumbs.length - 1], title: lastTitle };
    }

    const intermediateBreadcrumb = this.breadcrumbService.intermediateBreadcrumb$.value;
    if (intermediateBreadcrumb) {
      const index = breadcrumbs.findIndex(item => item.title === intermediateBreadcrumb.afterTitle);
      if (index >= 0) {
        breadcrumbs.splice(index + 1, 0, {
          title: intermediateBreadcrumb.title,
          url: intermediateBreadcrumb.url
        });
      }
    }
    this.pageInfo = { urls: breadcrumbs };
  }

  private getDeepestRoute(route: ActivatedRoute): ActivatedRoute {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current;
  }

  private buildBreadcrumb(): any[] {
    const breadcrumbs: any[] = [];
    const deepest = this.getDeepestRoute(this.activatedRoute);
    const id = deepest.snapshot?.paramMap?.get('id');
    let route: ActivatedRoute | null = this.activatedRoute.root;
    let url = '';


    while (route) {
      const data = route.snapshot?.data;
      if (data?.['title']) {
        const breadcrumbParam = data['breadcrumbParam'];
        const breadcrumbParamValue = breadcrumbParam ? route.snapshot?.paramMap?.get(breadcrumbParam) : null;

        if (breadcrumbParamValue) {
          breadcrumbs.push({ title: breadcrumbParamValue, url: url || '/' });
        } else {
          switch (data?.['title']) {
            case 'comId': {
              breadcrumbs.push({ title: 'companies', url: '/admin/companies' });
              breadcrumbs.push({ title: id != "new" ? 'detail' : id, url: url || '/' });
              break;
            }
            default:
              breadcrumbs.push({ title: data['title'], url: url || '/', type: data['type'], disabled: data['title'] === 'company' && !this.authService.userInfo?.isAdmin });
              break;
          }
        }
      }
      if (route.firstChild) {
        const path = route.firstChild.snapshot?.url?.map(seg => seg.path).join('/');
        if (path) url += '/' + path;
        route = route.firstChild;
      } else {
        route = null;
      }
    }
    return breadcrumbs;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
